import React, { Suspense } from 'react';
import ChunkErrorBoundary from './ChunkErrorBoundary';

/**
 * Wrapper pour les routes lazy avec gestion automatique des erreurs de chunks
 * ChunkErrorBoundary s'affiche en cas d'échec de chargement
 * Pas de fallback car les composants gèrent leur propre loading state
 */
const LazyRoute = ({ children }) => {
  return (
    <ChunkErrorBoundary>
      <Suspense fallback={null}>
        {children}
      </Suspense>
    </ChunkErrorBoundary>
  );
};

export default LazyRoute;
